import React from 'react';
import './Expertise.css';

import { Heading } from '../../../components';
import { expertise } from '../../../constants';



const Expertise = () => {

  return (
    <section className="custom-form expertise">
      <div className="box-container">
        <div className="content">
          <div className="text">

            {/* Section Heading */}
            <Heading title={expertise.heading} subTitle={expertise.sub} sideHeading linear />

            <p>{expertise.content}</p>

            {/* Expertise Points */}
            <div className="expertise-points">
              {expertise.points.map((point) => (
                <div className="box" key={point.id}>
                  <h3>
                    {point.title}
                    <span> {point.progress}% </span>
                  </h3>
                  <div className="progress-bar">
                    <span style={{ width: `${point.progress}%` }}></span>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Expertise;